import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import Login from '@/views/AppLogin.vue'
import AeroUpload from '@/views/AeroUpload.vue'
import PropertyTaxUpload from '@/views/PropertyTaxUpload.vue'
import { ROUTER_PATHS } from '@/constants/router/paths'
import { ROUTER_NAMES } from '@/constants/router/names'
import { useRouterStore } from '@/stores/routerStore'
import { storeToRefs } from 'pinia'
import UserManagement from '@/views/UserManagement.vue'
import MemberManagement from '@/views/MemberManagement.vue'
import { ACTION_TYPE, DUP_SCOPE } from '@/constants/router/auth'
import { authorityGuard } from './guard'
import { FeatureOptions } from '@/types/api/common/governmentSetting/queryGovernmentSettingResponseParam'

export const routes: RouteRecordRaw[] = [
  {
    path: ROUTER_PATHS.login,
    name: ROUTER_NAMES.login,
    component: Login,
    meta: {
      requiresAuth: false // [MiiaFW] 認証必須フラグ
    }
  },
  {
    path: ROUTER_PATHS.orgAdminManagement,
    name: ROUTER_NAMES.orgAdminManagement,
    component: UserManagement,
    beforeEnter: authorityGuard,
    meta: {
      requiresAuth: true, // [MiiaFW] 認証必須フラグ
      requiredAuthorities: [{ scope: DUP_SCOPE.dupUserManagement, actions: [ACTION_TYPE.read] }]
    }
  },
  {
    path: ROUTER_PATHS.orgMemberManagement,
    name: ROUTER_NAMES.orgMemberManagement,
    component: MemberManagement,
    beforeEnter: authorityGuard,
    meta: {
      requiresAuth: true, // [MiiaFW] 認証必須フラグ
      requiredAuthorities: [{ scope: DUP_SCOPE.dupOrgUserManagement, actions: [ACTION_TYPE.read] }]
    }
  },
  {
    path: ROUTER_PATHS.uploadAeroPic,
    name: ROUTER_NAMES.uploadAeroPic,
    component: AeroUpload,
    beforeEnter: authorityGuard,
    meta: {
      requiresAuth: true, // [MiiaFW] 認証必須フラグ
      requiredAuthorities: [
        { scope: DUP_SCOPE.dupAeroUpload, actions: [ACTION_TYPE.read, ACTION_TYPE.write] }
      ],
      requiredFeatureOption: FeatureOptions.screeningAuth
    }
  },
  {
    path: ROUTER_PATHS.uploadPropertyTax,
    name: ROUTER_NAMES.uploadPropertyTax,
    component: PropertyTaxUpload,
    beforeEnter: authorityGuard,
    meta: {
      requiresAuth: true, // [MiiaFW] 認証必須フラグ
      requiredAuthorities: [
        { scope: DUP_SCOPE.dupPropscrUpload, actions: [ACTION_TYPE.read, ACTION_TYPE.write] }
      ],
      requiredFeatureOption: FeatureOptions.propScrAuth
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes
})

router.beforeEach((_to, from) => {
  const routerStore = useRouterStore()
  const { previousPath } = storeToRefs(routerStore)
  previousPath.value = from.matched.length === 0 ? from.path : from.matched[0].path
})

export default router
